import { Controller } from '@hotwired/stimulus';

function calcularImporte(iva, baseImponible) {
  const baseImponibleBigDec = Number.parseFloat(baseImponible);
  const porcentajeIva = (iva / 100); // 0,21

  return {
    base_imponible: baseImponibleBigDec,
    importe: baseImponibleBigDec + (baseImponibleBigDec * porcentajeIva),
  };
}

function calcularBaseImponible(iva, importe) {
  const importeBigDec = Number.parseFloat(importe);
  const porcentajeIva = ((100 + (iva || 0)) / 100); // 1,21

  return {
    importe: importeBigDec,
    base_imponible: importeBigDec / porcentajeIva,
  };
}

// Aplicar estilo al elemento/mes especificado
// elementoWrapper es el <li> que está por encima de los checks
function aplicarClaseMes(elementoWrapper) {
  const $el = $(elementoWrapper);
  if ($el.find('input').is(':checked')) {
    $el.addClass('checked btn-cifra');
    $el.removeClass('btn-default');
  } else {
    $el.removeClass('checked btn-cifra');
    $el.addClass('btn-default');
  }
}

/* global $, swal */
export default class extends Controller {
  connect() {
    this.$form = $(this.element);
    this.#controlSelectorMeses();
    this.#controlPreciosIva();
    this.#conectarFormSubmit();
  }

  #conectarFormSubmit() {
    const modalidadId = this.$form.data('modalidad-id');
    const originalFormData = this.$form.serialize();

    this.$form.on('submit', () => {
      // Si hay que hacer el submit real le hacemos y reiniciamos variable
      if (this.submitReal) {
        this.submitReal = false;
        return true;
      }

      const formChanged = this.$form.serialize() !== originalFormData;
      if (modalidadId && formChanged) {
        swal(
          {
            title: 'Guardar modalidad',
            text: 'Al guardar la modalidad se <strong>actualizarán</strong> los datos de las <strong>suscripciones</strong> a dicha modalidad. <br/>¿Está seguro de querer continuar?',
            type: 'warning',
            html: true,
            showCancelButton: true,
            showLoaderOnConfirm: true,
            confirmButtonColor: '#fe1d12',
            confirmButtonText: 'Aceptar',
            closeOnConfirm: true,
          },
          (isConfirmed) => {
            if (isConfirmed) {
              this.submitReal = true;
              this.$form.submit();
            }
          },
        );
      } else {
        return true;
      }
      return false;
    });
  }

  // Calendario mensual que seleccionan qué meses aplica la modalidad
  #controlSelectorMeses() {
    const $calendarioContainer = this.$form.find('#month-calendar');
    const $periodicidadId = this.$form.find('#gestion_economica_modalidad_periodicidad_id');

    $periodicidadId.on('change', () => {
      // Mostrar calendario cuando periodicidad mensual
      if ($calendarioContainer.data('periodicidad-mensual') === $(':selected', $periodicidadId).text()) {
        $calendarioContainer.removeClass('hidden');
      } else {
        $calendarioContainer.addClass('hidden');
        // Limpiar meses seleccionados al cambiar de periodicidad
        $calendarioContainer.find('input').prop('checked', false);
        $calendarioContainer.find('li').each((_index, el) => { aplicarClaseMes(el); });
      }
    }).trigger('change');

    $calendarioContainer.find('li').on('click', function onClick() {
      // Marcar mes como seleccionado y aplicar estilo
      const $input = $(this).find('input');
      $input.prop('checked', !$input.is(':checked'));
      aplicarClaseMes(this);
    }).each(
      (_index, el) => { aplicarClaseMes(el); },
    );
  }

  #controlPreciosIva() {
    this.$baseImponible = this.$form.find('#gestion_economica_modalidad_base_imponible');
    this.$baseImponibleValor = this.$form.find('#gestion_economica_modalidad_base_imponible_valor');
    this.$importe = this.$form.find('#gestion_economica_modalidad_importe');
    this.$ivaId = this.$form.find('#gestion_economica_modalidad_iva_id');

    // Calcular importe desde la base imponible
    this.$baseImponible.on('change', () => {
      this.$baseImponibleValor.val(
        this.$baseImponible.autoNumeric('get'),
      );

      const iva = parseInt(this.$ivaId.find('option:selected').data('iva'), 10);
      const baseImponible = this.$baseImponibleValor.val();

      this.#asignarValoresPrecios(calcularImporte(iva, baseImponible));
    });

    // Calcular base imponible desde el importe
    this.$importe.on('change', () => {
      const iva = parseInt(this.$ivaId.find('option:selected').data('iva'), 10);
      const importe = this.$importe.autoNumeric('get');

      this.#asignarValoresPrecios(calcularBaseImponible(iva, importe));
    });

    // Calcular cantidades al cambiar el IVA; a partir de base imponible si esta está definida.
    this.$ivaId.on('change', () => {
      const iva = parseInt($('#gestion_economica_modalidad_iva_id').find('option:selected').data('iva'), 10);
      const baseImponible = $('#gestion_economica_modalidad_base_imponible_valor').val();
      const importe = $('#gestion_economica_modalidad_importe').autoNumeric('get');
      let results = {};

      if (this.$baseImponible.val()) {
        results = calcularBaseImponible(iva, importe);
      } else {
        results = calcularImporte(iva, baseImponible);
      }

      this.#asignarValoresPrecios(results);
    });
  }

  #asignarValoresPrecios(result) {
    this.$baseImponibleValor.val(result.base_imponible);
    this.$baseImponible.autoNumeric('set', result.base_imponible);
    this.$importe.autoNumeric('set', result.importe);
  }
}
